import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "6",
  cy: "6",
  r: "6"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "6",
  cy: "6",
  r: "5",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressDot',
  props: {
    progress: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(["stroke-lighten flex-none", {
      'fill-gray-600': props.progress == -1 || props.progress == 0,
      'fill-blue': props.progress == 1,
      'fill-orange': props.progress == 2,
      'fill-green': props.progress == 3,
      'fill-red': props.progress == 4,
      'fill-yellow-300': props.progress == 5,
    }]),
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none"
  }, _hoisted_3, 2))
}
}

})